var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCircles = function SvgCircles(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.5,
    height: 27.5
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#2d2e2d",
    strokeWidth: 1.5,
    "data-name": "Group 3243"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Ellipse 7",
    transform: "translate(6)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 8.5,
    r: 8.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 8.5,
    r: 7.75
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Ellipse 8",
    transform: "translate(0 10.5)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 8.5,
    r: 8.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 8.5,
    r: 7.75
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Ellipse 9",
    transform: "translate(12.5 10.5)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 8.5,
    r: 8.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 8.5,
    r: 7.75
  })))));
};
export { SvgCircles as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyOS41IiBoZWlnaHQ9IjI3LjUiIHZpZXdCb3g9IjAgMCAyOS41IDI3LjUiPg0KICA8ZyBpZD0iR3JvdXBfMzI0MyIgZGF0YS1uYW1lPSJHcm91cCAzMjQzIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTk5IC0zNzguNSkiPg0KICAgPGcgaWQ9IkVsbGlwc2VfNyIgZGF0YS1uYW1lPSJFbGxpcHNlIDciIHRyYW5zZm9ybT0idHJhbnNsYXRlKDIwNSAzNzguNSkiIGZpbGw9Im5vbmUiIHN0cm9rZT0iIzJkMmUyZCIgc3Ryb2tlLXdpZHRoPSIxLjUiPg0KICAgICAgPGNpcmNsZSBjeD0iOC41IiBjeT0iOC41IiByPSI4LjUiIHN0cm9rZT0ibm9uZSIvPg0KICAgICAgPGNpcmNsZSBjeD0iOC41IiBjeT0iOC41IiByPSI3Ljc1IiBmaWxsPSJub25lIi8+DQogICAgPC9nPg0KICAgIDxnIGlkPSJFbGxpcHNlXzgiIGRhdGEtbmFtZT0iRWxsaXBzZSA4IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxOTkgMzg5KSIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjMmQyZTJkIiBzdHJva2Utd2lkdGg9IjEuNSI+DQogICAgICA8Y2lyY2xlIGN4PSI4LjUiIGN5PSI4LjUiIHI9IjguNSIgc3Ryb2tlPSJub25lIi8+DQogICAgICA8Y2lyY2xlIGN4PSI4LjUiIGN5PSI4LjUiIHI9IjcuNzUiIGZpbGw9Im5vbmUiLz4NCiAgICA8L2c+DQogICAgPGcgaWQ9IkVsbGlwc2VfOSIgZGF0YS1uYW1lPSJFbGxpcHNlIDkiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDIxMS41IDM4OSkiIGZpbGw9Im5vbmUiIHN0cm9rZT0iIzJkMmUyZCIgc3Ryb2tlLXdpZHRoPSIxLjUiPg0KICAgICAgPGNpcmNsZSBjeD0iOC41IiBjeT0iOC41IiByPSI4LjUiIHN0cm9rZT0ibm9uZSIvPg0KICAgICAgPGNpcmNsZSBjeD0iOC41IiBjeT0iOC41IiByPSI3Ljc1IiBmaWxsPSJub25lIi8+DQogICAgPC9nPg0KICA8L2c+DQo8L3N2Zz4NCg==";